<template>
  <div id="app" class="" :style="styleVars">
    <div class="header">
      <div class="container mx-auto px-3">
        <div>
          <img
            v-if="$config.header.logo"
            class="mx-auto mb-5"
            :src="$config.header.logo"
          />
        </div>
        <div>
          <h1
            class="text-4xl font-bold py-6 md:py-0 mb-5"
            :style="`color: ${$config.header.color}`"
          >
            {{ $config.header.text[lang.code] || $config.header.text["en"] }}
          </h1>
        </div>
        <div>
          <img
            v-if="$config.header.companyLogo"
            class="mx-auto mb-5"
            :src="$config.header.companyLogo"
          />
        </div>
      </div>
    </div>
    <transition name="fade">
      <v-loader v-if="isLoading" />
    </transition>
    <transition name="fade">
      <div
        v-if="!isLoading && !isValidFavourites"
        class="text-center mb-6 flex items-center justify-center"
        style="height:30vh;"
      >
        No properties to display.
      </div>
    </transition>
    <transition name="fade">
      <v-favourites
        style="flex-grow: 1;"
        v-if="!isLoading && isValidFavourites"
      />
    </transition>
    <v-footer />
    <transition name="fade">
      <lead-form-modal
        v-if="
          !isLoading &&
            isValidFavourites &&
            !isReturningUser &&
            isLeadFormTimeoutFinished &&
            !isLeadFormSubmitted
        "
        @submitted="isLeadFormSubmitted = true"
      />
    </transition>
  </div>
</template>

<script>
import LeadFormModal from "./components/LeadFormModal";
// import loadConfig from '../config'
import VLoader from "./components/VLoader";
import VFavourites from "./components/VFavourites";
import VFooter from "./components/VFooter";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "App",
  components: {
    LeadFormModal,
    VLoader,
    VFavourites,
    VFooter,
  },

  data() {
    return {
      isLeadFormSubmitted: false,
    };
  },

  computed: {
    ...mapState(["lang", "langs"]),
    ...mapGetters([
      "isLeadFormTimeoutFinished",
      "isLoading",
      "isReturningUser",
      "isValidFavourites",
    ]),

    styleVars() {
      return {
        "--brand-color": this.$config.style.primaryColor,
        "--text-color": this.$config.style.textColor,
      };
    },
  },

  created() {
    this.fetchProperties();
  },

  methods: {
    ...mapActions(["fetchProperties"]),
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_fonts";
@import "@/assets/styles/_variables";

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // background-color: $navy;
  color: var(--text-color);
  font-family: $font-sans;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.font-serif {
  font-family: $font-serif;
}

.header {
  background-color: $brand-color;
  color: var(--text-color);
  margin-bottom: 30px;
  padding: 30px 0;

  > div {
    // text-align: center;
    align-items: center;
    display: flex;
    justify-content: space-between;

    img {
      max-height: 100px;
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      text-align: center;

      img {
        margin-bottom: 20px;
      }
    }
  }

  img {
    object-fit: contain;
    max-width: 100px;
    max-height: 50px;

    @media (min-width: 768px) {
      width: 180px;
    }
  }
}
</style>
